/**
 * Time as an injected dependency.
 *
 * Nearly everything this product does is time-triggered: reporting deadlines,
 * penalty-risk windows, the 7/14/30/45-day escalation ladder, invoice aging,
 * trial expiry. If any of that reads `new Date()` directly it becomes untestable
 * without waiting real days, so the clock is a port like any other.
 *
 * Israeli tax periods are civil-calendar months in Asia/Jerusalem. Storing
 * timestamptz and formatting in that zone is the only correct combination: DST
 * shifts twice a year and a naive local timestamp would silently move a
 * submission across a deadline boundary.
 */
export const JERUSALEM = "Asia/Jerusalem" as const;

export interface ClockPort {
  /** Current instant. Always UTC-based; render in a timezone at the edge. */
  now(): Date;
  /** The timezone business rules are evaluated in. */
  readonly timeZone: string;
}

export interface ControllableClock extends ClockPort {
  /** Pin the clock to an instant. */
  setNow(instant: Date): void;
  /** Move the clock forward (or back, with a negative value). */
  advance(ms: number): void;
  /** Return to following the system clock. */
  reset(): void;
}
